import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Link, navigate } from "@reach/router";
import {
  Title,
  Paragraph,
  SubTitle,
  DocImage,
  DocImages,
  NavigateButton,
  DocPaper,
  DocLink,
  Panel,
  Text,
  TextButton,
  TabWithContent,
  useDynamicImage
} from "../../../DocCreater";

//本文档的引用图片存放的位置
const imageFolder = "/images/learnpage/step2/";

const useStyles = makeStyles(theme => ({
  grid: {
    flexGrow: 1
  },
  stepperBar: {
    marginTop: theme.spacing(4)
  },
  divider: {
    width: "100%",
    height: 1
  },
  paper: {
    width: "100%"
  }
}));
// 构件基本信息文档
const Panel1 = props => {
  //使用动态说明图片
  const [docImageSrc1, setDocImageSrc1] = useDynamicImage(
    `${imageFolder}01-1.jpg`
  );
  const [docImageSrc2, setDocImageSrc2] = useDynamicImage(
    `${imageFolder}01-4.jpg`
  );
  return (
    <TabWithContent
      content={[
        {
          title: "资源简介",
          detail: (
            <>
              <Paragraph>
                包括清官式大木作中常见构件的基本信息，包括构件名称描述及分类、构件示意图、构件位置图、构件模型，分别介绍如下：
              </Paragraph>
              <DocImage imageSrc={docImageSrc1} />
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}01-1.jpg`);
                }}
              >
                <Text color="secondary">构件名称描述及分类：</Text>
                构件的学术名称、构件所属分类(采用营造算例中分类方式)、构件的基本描述(摘自《清式营造则例》)
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}01-2.jpg`);
                }}
              >
                <Text color="secondary">构件示意图:</Text>
                构件的示意性线图，通过模型渲染生成
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}01-3.jpg`);
                }}
              >
                <Text color="secondary">构件位置图:</Text>
                标红部分为构件在整体建筑或斗栱中的位置
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}01-7.png`);
                }}
              >
                <Text color="secondary">构件模型:</Text>
                构件3D模型，与模型的示意性线图保持一致，可以自由旋转缩放移动查看
              </Paragraph>
            </>
          )
        },
        {
          title: "操作指南",
          detail: (
            <>
              <Paragraph>包括如下几项常见操作方式</Paragraph>
              <DocImage imageSrc={docImageSrc2} />
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}01-4.jpg`);
                }}
              >
                <Text color="secondary">切换构件示意图与构件位置图:</Text>
                点击红色区域的箭头按钮，即可在构件示意图与构件位置图中切换
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}01-3.jpg`);
                }}
              >
                <Text color="secondary">
                  查看构件示意图及位置图原尺寸高清图:
                </Text>
                单击红色区域，即可在新页面上显示100%尺寸原图
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}01-5.jpg`);
                }}
              >
                <Text color="secondary">查看构件模型:</Text>
                点击红框内3D按钮即可在弹出框内查看构件3D模型，并且可以使用左键旋转模型，右键平移模型，滚轮缩放模型
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}01-6.jpg`);
                }}
              >
                <Text color="secondary">更新构件信息:</Text>
                点击红框中按钮，在弹出框内更新信息，点击提交后即可实时更新构件基本信息，如更新时不上传新图片或模型，则默认保持原有图片与模型(仅教师可使用此功能)
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}01-8.png`);
                }}
              >
                <Text color="secondary">构件过滤功能:</Text>
                在构件上方文本框可分别过滤构件名称，构件描述，与构件类型，系统会在每次输入后自动进行过滤，过滤结果为同时满足三个过滤条件的构件，如不填写或不选择即为默认不过滤此项
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}01-9.jpg`);
                }}
              >
                <Text color="secondary">查看构件详情:</Text>
                点击红框内按钮，即可在新打开页面中查看构件相关的所有信息，包括此构件的相关图纸照片、文献中摘录的相关条文等
              </Paragraph>
            </>
          )
        },
        {
          title: "权限设置",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">未登录用户:</Text>
                未登录用户，无法查看构件基本信息列表，请登录后查看
              </Paragraph>
              <Paragraph>
                <Text color="secondary">登录用户:</Text>
                登录用户均可查看构件的所有基本信息，包括文本、图片、模型
              </Paragraph>
              <Paragraph>
                <Text color="secondary">教师:</Text>
                教师可对构件基本信息进行修改，重新修订文字描述，名称，选择所属分类，并更新构件示意图及3D模型
              </Paragraph>
            </>
          )
        },
        {
          title: "格式说明",
          detail: (
            <>
              <Paragraph>更新构件信息时需注意以下几项格式内容</Paragraph>
              <DocImage imageSrc={`${imageFolder}01-10.png`} />

              <Paragraph>
                <Text color="secondary">必填项:</Text>
                构件名称、构件解释、构件类型均为必填项
              </Paragraph>
              <Paragraph>
                <Text color="secondary">构件示意图:</Text>
                jpg图片格式，系统会自动从中间裁剪方形区域作为缩略图使用，故建议上传方形图片
              </Paragraph>
              <Paragraph>
                <Text color="secondary">3D模型:</Text>
                obj格式3D模型，模型坐标原点将作为查看时的旋转中心使用，建议将模型几何中心置于原点后再导出上传
              </Paragraph>
            </>
          )
        }
      ]}
    />
  );
};
// 营造文献文档
const Panel2 = props => {
  //使用动态说明图片
  const [docImageSrc1, setDocImageSrc1] = useDynamicImage(
    `${imageFolder}02-2.jpg`
  );
  const [docImageSrc2, setDocImageSrc2] = useDynamicImage(
    `${imageFolder}01-4.jpg`
  );
  return (
    <TabWithContent
      content={[
        {
          title: "资源简介",
          detail: (
            <>
              <Paragraph>
                与清官式建筑营造相关的文献，分为古籍、期刊、专著三种类型，包含文献的名称、摘要、版本、作者、类型及电子文件,如下图所示
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}02-1.jpg`} />
            </>
          )
        },
        {
          title: "操作指南",
          detail: (
            <>
              <Paragraph>文献页面包含如下几项功能</Paragraph>
              <DocImage imageSrc={docImageSrc1} />

              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}02-2.jpg`);
                }}
              >
                <Text color="secondary">文献过滤功能:</Text>
                在红框内输入过滤条件，过滤结果为同时满足所有过滤条件的文献，如不填写或不选择即为默认不过滤此项
              </Paragraph>

              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}02-3.jpg`);
                }}
              >
                <Text color="secondary">查看文献电子版:</Text>
                点击红框内PDF按钮，即可在新弹出窗口中查看电子版文献，也可在新弹出窗口点击右键菜单下载文献
              </Paragraph>

              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}02-4.jpg`);
                }}
              >
                <Text color="secondary">新建文献:</Text>
                点击红框中按钮，在弹出框内新建文献，点击提交后即可新建文献(仅教师可使用此功能)
              </Paragraph>

              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}02-5.jpg`);
                }}
              >
                <Text color="secondary">更新文献:</Text>
                点击红框中按钮，在弹出框内更新本条文献的信息，提交后即可实时更新文献基本信息，如更新时不上传新PDF文件，则默认保持原有PDF文件(仅教师可使用此功能)
              </Paragraph>

              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}02-6.jpg`);
                }}
              >
                <Text color="secondary">删除文献:</Text>
                点击红框内按钮，即可删除本条文献，但是如果已有构件条文绑定在该文献上，则不可删除本条文献(仅教师可使用此功能)
              </Paragraph>
            </>
          )
        },
        {
          title: "权限设置",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">未登录用户:</Text>
                未登录用户，无法查看营造文献相关的任何信息，请登录后使用
              </Paragraph>
              <Paragraph>
                <Text color="secondary">登录用户:</Text>
                登录用户均可查看文献相关的信息，并且可以阅读文献电子版
              </Paragraph>
              <Paragraph>
                <Text color="secondary">教师:</Text>
                教师可对文献的基本信息进行修改或删除，同时可新增文献，新增后的文献即会出现在构件条文录入时的文献选择框里，任何文献下如果有绑定的构件条文，此文献即受到保护，任何人无法删除
              </Paragraph>
            </>
          )
        },
        {
          title: "格式说明",
          detail: (
            <>
              <Paragraph>更新或新建文献时需注意以下几项格式内容</Paragraph>
              <DocImage imageSrc={`${imageFolder}02-7.png`} />

              <Paragraph>
                <Text color="secondary">必填项:</Text>
                文献名称、作者、版本、摘要、类型均为必填项
              </Paragraph>
              <Paragraph>
                <Text color="secondary">文献电子文件:</Text>
                请上传PDF格式，上传时请确认版权可供使用，可选择不上传则查看文献一栏中PDF按钮不会显示
              </Paragraph>
            </>
          )
        }
      ]}
    />
  );
};
// 构件条文文档
const Panel3 = props => {
  //使用动态说明图片
  const [docImageSrc1, setDocImageSrc1] = useDynamicImage(
    `${imageFolder}03-2.jpg`
  );
  const [docImageSrc2, setDocImageSrc2] = useDynamicImage(
    `${imageFolder}01-4.jpg`
  );
  return (
    <TabWithContent
      content={[
        {
          title: "资源简介",
          detail: (
            <>
              <Paragraph>
                从清官式营造文献中摘录的条文，包含条文的原文已经对条文的注释解读及章节出处，每条条文同时关联外键指向对应的构件及文献，下图即为某一构件详情页面中与本构件有关的条文列表，也可以在
                <DocLink to="/info/tiaowens/" newpage>
                  条文列表
                </DocLink>
                页面查看所有条文
              </Paragraph>
              <Paragraph />
              <DocImage imageSrc={`${imageFolder}03-1.jpg`} />
            </>
          )
        },
        {
          title: "操作指南",
          detail: (
            <>
              <Paragraph>条文列表包含如下几项功能</Paragraph>
              <DocImage imageSrc={docImageSrc1} />

              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}03-2.jpg`);
                }}
              >
                <Text color="secondary">条文过滤功能:</Text>
                在红框内输入过滤条件，过滤结果为同时满足所有过滤条件的条文，如不填写即为默认不过滤此项
              </Paragraph>

              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}03-3.jpg`);
                }}
              >
                <Text color="secondary">新建条文:</Text>
                点击红框内按钮，即可在新弹出窗口中新增条文，也可在构件列表页面单击"新建条文"按钮直接为该构件添加条文
              </Paragraph>

              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}03-4.jpg`);
                }}
              >
                <Text color="secondary">更新条文:</Text>
                点击红框中按钮，在弹出框内更新条文的内容(仅条文录入人或教师可更新本条文)
              </Paragraph>

              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}03-5.jpg`);
                }}
              >
                <Text color="secondary">删除条文:</Text>
                点击红框内按钮，即可删除本条条文(仅条文录入人或教师可删除本条文)
              </Paragraph>
            </>
          )
        },
        {
          title: "权限设置",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">未登录用户:</Text>
                未登录用户，无法查看条文相关的任何信息，请登录后使用
              </Paragraph>
              <Paragraph>
                <Text color="secondary">登录用户:</Text>
                登录用户均可查看所有人上传的条文信息，并且可以创建条文，修改或删除自己创建的条文(不可修改或删除他人上传的条文)
              </Paragraph>
              <Paragraph>
                <Text color="secondary">教师:</Text>
                教师可新增，修改，删除任意条文(包括其他用户上传的条文)
              </Paragraph>
            </>
          )
        },
        {
          title: "字段说明",
          detail: (
            <>
              <DocImage imageSrc={`${imageFolder}03-6.png`} />

              <Paragraph>更新或新建文献时需注意以下几项格式内容</Paragraph>
              <Paragraph>
                <Text color="secondary">必填项:</Text>
                条文内容、所属构件及出自文献为必填项，其中构件会自动根据创建时点击的按钮所属的构件自动生成，无需手动添加
              </Paragraph>
              <Paragraph>
                <Text color="secondary">可选项:</Text>
                文献详解及章节出处为可选项，不填写仍可创建新条文
              </Paragraph>
              <Paragraph>
                <Text color="secondary">条文内容:</Text>
                条文内容为必填项，应当填写条文原文，不要自行修改
              </Paragraph>
              <Paragraph>
                <Text color="secondary">文献:</Text>
                文献应当从录入的参考文献中选取，系统会自动根据所有参考文献生成选项菜单
              </Paragraph>
            </>
          )
        }
      ]}
    />
  );
};

// 构件图纸照片文档
const Panel4 = props => {
  //使用动态说明图片
  const [docImageSrc1, setDocImageSrc1] = useDynamicImage(
    `${imageFolder}04-2.jpg`
  );

  return (
    <TabWithContent
      content={[
        {
          title: "资源简介",
          detail: (
            <>
              <Paragraph>
                该资源为某一构件相关的图纸及照片，包括图纸或照片的原始文件、缩略图、描述文本、所属建筑，在构件详情页面里，使用一个带过滤的图片列表展示，如下图所示
              </Paragraph>
              <Paragraph />
              <DocImage imageSrc={`${imageFolder}04-1.jpg`} />
            </>
          )
        },
        {
          title: "操作指南",
          detail: (
            <>
              <Paragraph>图片列表包含如下几项操作方式及功能</Paragraph>
              <DocImage imageSrc={docImageSrc1} />
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}04-2.jpg`);
                }}
              >
                <Text color="secondary">进入构件图纸照片列表:</Text>
                在构件列表中点击构件卡片左上角红框中的按钮，即可在弹出的构件详情页面，查看与本构件相关的图纸及照片
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}04-3.jpg`);
                }}
              >
                <Text color="secondary">图片过滤功能:</Text>
                在红框内输入过滤条件，过滤结果为同时满足所有过滤条件的图片，如不填写即为默认不过滤此项
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}04-4.jpg`);
                }}
              >
                <Text color="secondary">查看图片信息:</Text>
                将鼠标移至图片上红框内，即可弹出悬浮框，显示本图片的相关信息
              </Paragraph>{" "}
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}04-5.jpg`);
                }}
              >
                <Text color="secondary">查看大图功能:</Text>
                点击想要查看的图片，即可查看大图
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}04-6.jpg`);
                }}
              >
                <Text color="secondary">新建图纸照片:</Text>
                点击红框内按钮，即可在新弹出窗口中新增图纸或照片
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}04-7.jpg`);
                }}
              >
                <Text color="secondary">更新图纸照片信息:</Text>
                点击红框中按钮，在弹出框内更新图纸或照片的信息(仅图片录入人或教师可更新本图片信息)
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}04-8.jpg`);
                }}
              >
                <Text color="secondary">删除图片:</Text>
                点击红框内按钮，即可删除本图片(仅图片录入人或教师可删除本图片)
              </Paragraph>
            </>
          )
        },
        {
          title: "权限设置",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">未登录用户:</Text>
                未登录用户，无法查看任何图纸照片信息，请登录后使用
              </Paragraph>
              <Paragraph>
                <Text color="secondary">登录用户:</Text>
                登录用户均可查看所有人上传的图纸照片，并且可以创建新图片照片，修改或删除自己创建的图纸照片(不可修改或删除他人上传的图纸照片)
              </Paragraph>
              <Paragraph>
                <Text color="secondary">教师:</Text>
                教师可新增，修改，删除任意图纸照片(包括其他用户上传的图纸照片)
              </Paragraph>
            </>
          )
        },
        {
          title: "字段说明",
          detail: (
            <>
              <DocImage imageSrc={`${imageFolder}04-9.png`} />

              <Paragraph>更新或新建图纸照片时需注意以下几项格式内容</Paragraph>
              <Paragraph>
                <Text color="secondary">图片:</Text>
                选择清晰的与构件相关的图片，图片必须清晰明确反映所属构件，系统会自动截取最大的方形区域生成缩略图，更新信息时，可不填此项，则图片保持不变只更新其他信息
              </Paragraph>
              <Paragraph>
                <Text color="secondary">图片描述:</Text>
                必填项，所上传的图纸照片的内容描述文本
              </Paragraph>
              <Paragraph>
                <Text color="secondary">所属建筑:</Text>
                必填项，所上传的图纸照片所属的建筑，照片填写此照片所出自的建筑，精确到单体建筑为宜，图纸如果是据实际建筑绘制，则应当同样填写相应的建筑单体名称，如果不是据实际建筑绘制则填写绘制依据作为虚拟的建筑出处
              </Paragraph>
              <Paragraph>
                <Text color="secondary">图片类型:</Text>
                必填项，从图纸或照片中选择一个即可
              </Paragraph>
            </>
          )
        }
      ]}
    />
  );
};

//构件辨识实验文档
const TestPanel = props => {
  //使用动态说明图片
  const [docImageSrc1, setDocImageSrc1] = useDynamicImage(
    `${imageFolder}05-2.jpg`
  );
  const [docImageSrc2, setDocImageSrc2] = useDynamicImage(
    `${imageFolder}06-2.png`
  );
  return (
    <TabWithContent
      content={[
        {
          title: "实验步骤",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">构件认知学习模块:</Text>
                提供基本的构件信息学习，可供学生自主学习各个构件，掌握清官式大木作基础知识；学生首先通过本模块学习各类清官式大木作构件的名称、位置、描述等基础信息，查看构件的图纸、照片、重要营造文献中对构件的记载，掌握清官式大木作的基础知识；并通过构件辨识实验检验自身学习成果，不断巩固基础知识。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou2.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤2:</Text>
                学生点击导航栏“构件认知”栏目，默认进入子栏目“构件列表”，进入构件认知模块；依次查看构件认知模块中每个构件的卡片，点击卡片上图片查看详细图纸，切换位置图与透视图，了解构件样式与位置，阅读构件描述，点击3D按钮，查看构件3D模型；同时通过构件名称过滤、构件描述过滤、构件类型过滤检索功能辅助自身学习；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou3-1.jpg`} />
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou3-2.jpg`} />

              <Paragraph>
                <Text color="secondary">步骤3:</Text>
                点击本页面上方子栏目“参考文献”、“构件条文”，了解相关的清官式重要营造文献与专著，并可阅读原书PDF。参考文献与构件条文均可进行过滤查询，以便检索学习；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou4.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤4:</Text>
                点击每个卡片右上角详情按钮，进入单个构件详情页面，查看构件的详细信息，查阅构件图纸照片高清图、阅读构件在《清式营造则例》、《营造算例》、《工程做法》等重要文献中的记载与阐述，进一步深入学习各个构件的相关知识；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou5.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤5:</Text>
                点击本页面上方子栏目“辨识实验”，进入构件辨识实验，实验随机选取20个构件，通过透视图、位置图、3D模型考察学生对于构件的掌握程度，学生完成做答后，点击提交全部按钮，可查看作答正误情况，正误情况显示之后，作答卡片恢复交互状态，可直接用于学习并查看构件详情；
              </Paragraph>
            </>
          )
        },
        {
          title: "操作指南",
          detail: (
            <>
              <Paragraph>进入构件辨识实验页面后，可进行如下操作</Paragraph>
              <DocImage imageSrc={docImageSrc1} />
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}05-2.jpg`);
                }}
              >
                <Text color="secondary">切换构件示意图与位置图:</Text>
                点击红框内箭头按钮，即可从位置图切换至示意图，反之可从示意图切换回位置图
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}05-3.jpg`);
                }}
              >
                <Text color="secondary">查看构件位置图或示意图大图:</Text>
                点击红框中图片，即可在弹出框内查看本图片大图，以便测试时仔细查看辨识
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}05-4.jpg`);
                }}
              >
                <Text color="secondary">查看构件模型:</Text>
                点击红框内3D按钮，即可在弹出框查看构件模型
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}05-5.jpg`);
                }}
              >
                <Text color="secondary">提交单个答案:</Text>
                填写试题答案后，点击测试卡片上上提交按钮，可单独提交该构件答案，系统会立即反馈评判结果，并显示正确答案，提交单个试题答案不会将试卷成绩提交至服务器，但提交后的答案将不可修改
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}05-6.jpg`);
                }}
              >
                <Text color="secondary">提交全部答案:</Text>
                点击红框内按钮，即可提交全部试题答案，系统会立即评判所有试题结果，得出测试成绩，并显示全部正确答案，同时将测试成绩及试卷详情提交至服务器
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}05-7.jpg`);
                }}
              >
                <Text color="secondary">提交后操作:</Text>
                完成提交后的测试卡片，会变化为学习卡片，会显示学生作答正误，并且生成详情按钮，可点击红框内详情按钮，查看该构件详情页面
              </Paragraph>
            </>
          )
        },
        {
          title: "实验成绩",
          detail: (
            <>
              <>
                <DocImage imageSrc={`${imageFolder}06-1.png`} />
                <Paragraph>
                  实验成绩将显示在我的成绩页面，学生可点击页面右上角菜单(如上图)，进入此页面
                </Paragraph>
                <DocImage imageSrc={docImageSrc2} />
                <Paragraph
                  onMouseOver={() => {
                    setDocImageSrc2(`${imageFolder}06-2.png`);
                  }}
                >
                  <Text color="secondary">各实验成绩分布图:</Text>
                  学生可查看个人最高分、最低分、全体平均分，教师可查看全体学生最高分、最低分、平均分
                </Paragraph>
                <Paragraph
                  onMouseOver={() => {
                    setDocImageSrc2(`${imageFolder}06-3.png`);
                  }}
                >
                  <Text color="secondary">实验完成次数饼图:</Text>
                  学生可查看个人对各个实验的完成情况，教师可查看全体学生的实验完成情况
                </Paragraph>
                <Paragraph
                  onMouseOver={() => {
                    setDocImageSrc2(`${imageFolder}06-4.png`);
                  }}
                >
                  <Text color="secondary">实验详情表:</Text>
                  学生可查看个人每次实验完成的详细情况，教师可查看全体学生所有实验完成情况数据，并且可以进行筛选过滤
                </Paragraph>
                <Paragraph
                  onMouseOver={() => {
                    setDocImageSrc2(`${imageFolder}06-5.png`);
                  }}
                >
                  <Text color="secondary">构件辨识实验试卷详情:</Text>
                  点击查看试卷按钮，可查看每次构件辨识实验的详细试卷情况
                </Paragraph>
              </>
            </>
          )
        }
      ]}
    />
  );
};
// 学习资源分类介绍文档，Panel方式交互展示
const resourcesPanelContent = [
  {
    panelTitle: (
      <Text color="primary" to="/info/goujians/" newpage>
        清官式大木作构件基本信息
      </Text>
    ),
    panelDetail: <Panel1 />
  },
  {
    panelTitle: (
      <Text color="primary" to="/info/wenxians/" newpage>
        清官式建筑营造文献
      </Text>
    ),
    panelDetail: <Panel2 />
  },
  {
    panelTitle: (
      <Text color="primary" to="/info/tiaowens/" newpage>
        清官式大木作构件条文
      </Text>
    ),
    panelDetail: <Panel3 />
  },
  {
    panelTitle: (
      <Text color="primary" to="/info/goujians/" newpage>
        构件图纸照片
      </Text>
    ),
    panelDetail: <Panel4 />
  }
];

function Step2(props) {
  const classes = useStyles();
  return (
    <DocPaper>
      <Title>构件认知学习模块</Title>
      <TestPanel />

      <SubTitle>教学资源库介绍</SubTitle>
      {resourcesPanelContent.map(({ panelTitle, panelDetail }, index) => (
        <Panel panelTitle={panelTitle} panelDetail={panelDetail} key={index} />
      ))}

      <NavigateButton
        icon
        to="/learn/step/3"
        buttonText="下一步"
        iconStyle={{
          float: "right"
        }}
      />
    </DocPaper>
  );
}

export default Step2;
